var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPaperclip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "paperclip"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.6668 3.99946L5.05695 9.72402C4.80683 9.97414 4.66632 10.3134 4.66632 10.6671C4.66632 11.0208 4.80683 11.3601 5.05695 11.6102C5.30707 11.8603 5.64631 12.0008 6.00003 12.0008C6.35376 12.0008 6.69299 11.8603 6.94311 11.6102L12.5529 5.88565C13.0531 5.38549 13.334 4.70713 13.334 3.9998C13.334 3.29246 13.0531 2.6141 12.5529 2.11394C12.0528 1.61379 11.3744 1.3328 10.6671 1.3328C9.95977 1.3328 9.28142 1.61379 8.78126 2.11394L3.1948 7.81517C2.81837 8.18552 2.51899 8.62674 2.31393 9.11338C2.10887 9.60002 2.00218 10.1224 2.00003 10.6505C1.99788 11.1786 2.10031 11.7019 2.3014 12.1902C2.50249 12.6785 2.79827 13.1221 3.17167 13.4955C3.54507 13.8689 3.98871 14.1647 4.477 14.3658C4.96528 14.5669 5.48855 14.6693 6.01662 14.6672C6.54469 14.665 7.06711 14.5583 7.55374 14.3533C8.04037 14.1482 8.48159 13.8488 8.85194 13.4724L14.4384 7.77116",
    stroke: "#757575",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPaperclip);
export default __webpack_public_path__ + "static/media/icon-paperclip.59de4e3f2f3de5d9729ddd96ef5ba866.svg";
export { ForwardRef as ReactComponent };